import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const LineItemActionOverride = React.createContext({ debugPOSTEnabled: false });

/**
 * Responsible for determining whether dynamic line item actions (edit with POST, update shipping address, cancel etc.) should be shown
 */
const LineItemActionOverrideProvider = ({ children }) => {
  const [currentDebugPOSTEnabled, setDebugPOSTEnabled] = useState(false);

  const lineItemActionOverrideContextValues = useMemo(
    () => ({
      debugPOSTEnabled: currentDebugPOSTEnabled,
      setDebugPOSTEnabled,
    }),
    [currentDebugPOSTEnabled, setDebugPOSTEnabled]
  );

  return (
    <LineItemActionOverride.Provider
      value={lineItemActionOverrideContextValues}
    >
      {children}
    </LineItemActionOverride.Provider>
  );
};

LineItemActionOverrideProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export { LineItemActionOverride, LineItemActionOverrideProvider };
